import {createClient} from '@supabase/supabase-js'
// import {supabase} from '@/supabase'
import {createRealtimeSessionId} from '@/utils/supabase-realtime'

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL
const supabaseAnonKey = process.env.VUE_APP_SUPABASE_ANON_KEY
const OWNER_HASH_HEADER = 'x-visibility-hash'

const createOwnerClient = (hash) => {
  if (!hash) {
    throw new Error('Visibility owner hash is required')
  }

  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Supabase config is missing')
  }

  return createClient(supabaseUrl, supabaseAnonKey, {
    auth: {
      persistSession: false,
      autoRefreshToken: false
    },
    global: {
      headers: {
        [OWNER_HASH_HEADER]: hash
      }
    }
  })
}

const getOwnerHash = (rootState) => {
  const hash = rootState?.auth?.user?.hash
  if (!hash) {
    throw new Error('User hash is not available')
  }
  return hash
}

const state = () => ({
  loading: false
})

const actions = {
  async createVisibilityElement ({rootState}) {
    const hash = getOwnerHash(rootState)
    const ownerClient = createOwnerClient(hash)

    const id = createRealtimeSessionId('visibility')
    const {error} = await ownerClient.from('public_visibility_elements').insert({
      old_id: id,
      state: true
    })

    if (error) {
      throw error
    }

    const {error: accessError} = await ownerClient.from('public_visibility_element_access').insert({
      element_id: id,
      owner_hash: hash
    })

    if (accessError) {
      throw accessError
    }

    return id
  },
  async updateVisibilityElement ({state, rootState}, payload) {
    state.loading = true
    const hash = getOwnerHash(rootState)
    const ownerClient = createOwnerClient(hash)
    const elementId = payload.id.toString()

    const {error} = await ownerClient.from('public_visibility_elements').upsert(
      {
        old_id: elementId,
        state: payload.state
      },
      {
        onConflict: 'old_id'
      }
    )

    if (error) {
      state.loading = false
      throw error
    }

    // Ensure access row exists (ignore conflict if already present)
    await ownerClient.from('public_visibility_element_access').upsert(
      {
        element_id: elementId,
        owner_hash: hash
      },
      {
        onConflict: 'element_id',
        ignoreDuplicates: true
      }
    )

    state.loading = false
  },
  async deleteVisibilityElement ({state, rootState}, id) {
    state.loading = true
    const hash = getOwnerHash(rootState)
    const ownerClient = createOwnerClient(hash)

    const {error} = await ownerClient
      .from('public_visibility_elements')
      .delete()
      .eq('old_id', id.toString())

    if (error) {
      state.loading = false
      throw error
    }

    state.loading = false
  }
}

export default {
  namespaced: true,
  state,
  actions
}
